<template>
  <div id="countdown" class="mt-2 mt-md-3 pb-4 pb-md-5">
    <div class="wrap">
      <div class="item days">
        <p class="number" :style="progressCirclesStyle">{{ days }}</p>
        <p class="units">{{ daysLabel }}</p>
        <ProgressCircle :currentTime="days" :maxTime="maxTimeDays" :diameter="progressCircleDiameter" isDays />
      </div>
      <div class="item hours">
        <p class="number" :style="progressCirclesStyle">{{ hours }}</p>
        <p class="units">{{ hoursLabel }}</p>
        <ProgressCircle :currentTime="hours" :maxTime="24" :diameter="progressCircleDiameter" />
      </div>
      <div class="item minutes">
        <p class="number" :style="progressCirclesStyle">{{ minutes }}</p>
        <p class="units">{{ minutesLabel }}</p>
        <ProgressCircle :currentTime="minutes" :maxTime="60" :diameter="progressCircleDiameter" />
      </div>
      <div class="item seconds">
        <p class="number" :style="progressCirclesStyle">{{ seconds }}</p>
        <p class="units">{{ secondsLabel }}</p>
        <ProgressCircle :currentTime="seconds" :maxTime="60" :diameter="progressCircleDiameter" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import ProgressCircle from './ProgressCircle';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

let startDate = dayjs.tz('2023-06-08 10:00:00', 'America/New_York');
if (startDate.diff(dayjs()) > 0 && !APP_addDays) {
  startDate = dayjs(); // if we're ahead of launch, just set to today's date so the circles display
}
const endDate = dayjs.tz('2024-07-18 02:30:00', 'America/New_York');
//const endDate = dayjs('2023-07-27T06:00:00-04:00');
const progressCircleDiameter = ref(100);
const progressCircleFontSize = ref(36);

// console.log(startDate, endDate);

const days = ref(0);
const hours = ref(0);
const minutes = ref(0);
const seconds = ref(0);

const daysLabel = ref('Days');
const hoursLabel = ref('Hours');
const minutesLabel = ref('Minutes');
const secondsLabel = ref('Seconds');

let interval = null;

function timerCount(start, end) {
  let now;
  if (APP_addDays) {
    now = dayjs().add(APP_addDays, 'days');
  } else {
    now = dayjs();
  }

  // Find the distance between now and the countdown date
  let distance = start - now;
  let passTime = end - now;

  if (distance < 0 && passTime < 0) {
    // EXPIRED
    clearInterval(interval);
    window.location.replace(APP_offerUrl);
  } else if (distance < 0 && passTime > 0) {
    // RUNNING
    calcTime(passTime);
  }
}

function calcTime(dist) {
  dist = parseInt(dist);
  // Time calculations for days, hours, minutes and seconds
  days.value = Math.floor(dist / (1000 * 60 * 60 * 24));
  hours.value = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  minutes.value = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
  seconds.value = Math.floor((dist % (1000 * 60)) / 1000);

  days.value === 1 ? daysLabel.value = 'Day' : daysLabel.value = 'Days';
  hours.value === 1 ? hoursLabel.value = 'Hour' : hoursLabel.value = 'Hours';
  minutes.value === 1 ? minutesLabel.value = 'Minute' : minutesLabel.value = 'Minutes';
  seconds.value === 1 ? secondsLabel.value = 'Second' : secondsLabel.value = 'Seconds';
}

const start = new Date(startDate).getTime();
const end = new Date(endDate).getTime();

timerCount(start, end);

// Update the countdown every 1 second
interval = setInterval(() => {
  timerCount(start, end);
}, 1000);

const maxTimeDays = computed(() => {
  return endDate.diff(startDate, 'day');
});

const progressCirclesStyle = computed(() => {
  const bp = 768;

  function updateProgressCircleDiameter() {
    const vpw = window.innerWidth;

    if (vpw <= bp) {
      progressCircleDiameter.value = 68;
      progressCircleFontSize.value = 24;
    } else {
      progressCircleDiameter.value = 100;
      progressCircleFontSize.value = 36;
    }
  }

  updateProgressCircleDiameter();
  window.addEventListener('resize', updateProgressCircleDiameter);

  const d = progressCircleDiameter.value;
  const fz = progressCircleFontSize.value;

  return `width: ${d}px; height: ${d}px; font-size: ${fz}px;`;
});
</script>
